import { SelectLocationAndSubLocation } from "./SelectLocationAndSubLocation.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/modules/Locations/shared/FormikSelectLocationAndSubLocation.tsx
var FormikSelectLocationAndSubLocation = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(SelectLocationAndSubLocation, {
				...props,
				error: (meta.touched || !!form.submitCount) && meta.error,
				valid: meta.touched && meta.value && !meta.error,
				...field,
				onChange: null,
				onChangeValue: (value) => {
					if (props.name) form.setFieldValue(props.name, value);
					if (!value || !value?.length) form.setFieldValue(props.subLocationName, null);
				},
				onChangeSubLocationValue: (value) => {
					form.setFieldValue(props.subLocationName, value);
				},
				subLocationValue: form.values?.[props.subLocationName]
			});
		}
	});
};
//#endregion
export { FormikSelectLocationAndSubLocation };

//# sourceMappingURL=FormikSelectLocationAndSubLocation.js.map